import { useSetDisplayPreference } from "@/hooks/usePubmed";
import { pubmedState } from "@/stores/pubmed";
import { IconButton } from "@material-ui/core";
import EventNoteOutlinedIcon from "@material-ui/icons/EventNoteOutlined";
import React from "react";
import { useRecoilValue } from "recoil";

const key = "CollectorComment";

const CommentButton: React.FC = () => {
  const {
    displayPreference: { verbose, defaultActiveKey },
  } = useRecoilValue(pubmedState);
  const { updatePreference, loading } = useSetDisplayPreference();

  return (
    <IconButton
      color="primary"
      onClick={() =>
        updatePreference(
          {
            verbose: verbose && defaultActiveKey !== key ? true : !verbose,
            defaultActiveKey: key,
          },
          true
        )
      }
      disabled={loading}
    >
      <EventNoteOutlinedIcon />
    </IconButton>
  );
};

export default CommentButton;
